<template>
    <div
        class="relative flex items-center flex-grow w-full col-span-1 px-4 py-6 mb-4 bg-white border border-gray-200 rounded shadow-sm"
    >
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto ">
                <div
                    @click="show = !show"
                    class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 text-gray-500 border-b border-l border-gray-100 cursor-pointer hover:text-gray-900"
                >
                    <svg
                        v-show="show"
                        class="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                        ></path>
                    </svg>
                    <svg
                        v-show="!show"
                        class="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 15l7-7 7 7"
                        ></path>
                    </svg>
                </div>
                <div class="flex justify-between" v-show="show">
                    <h2
                        @click="show = !show"
                        class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10"
                    >
                        {{ client.name }}
                    </h2>
                    <div @click="removeClient">
                        <base-icon
                            width="60"
                            height="60"
                            class="h-8 cursor-pointer"
                            icon-name="trash"
                            viewBox="0 0 20 20 "
                            iconColor="#6C98C6"
                        >
                            <icon-trash />
                        </base-icon>
                    </div>
                </div>
                <div v-show="!show">
                    <tag-group :tags="tags" @clicked="checkClientType" />
                    <base-input
                        placeholder="Profil/Nom du Client/Fournisseur"
                        v-model="client.name"
                        :hasError="$v.client.name.$error"
                        :errorMessage="
                            errorMessage(
                                'Nom Client/ Fournisseur',
                                $v.client.name
                            )
                        "
                        @blur="$v.client.name.$touch()"
                    />
                    <div
                        v-if="!isSimplifiedVersion"
                        class="mt-4 ml-3 text-left"
                    >
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >Origine du client</label
                        >
                        <radio-box
                            label="Local"
                            :name="`clientOrigin${client.id}`"
                            :value="client.clientOrigin"
                            @change="payload => (client.clientOrigin = payload)"
                        />
                        <radio-box
                            class="ml-6"
                            label="Étranger"
                            :name="`clientOrigin${client.id}`"
                            :value="client.clientOrigin"
                            @change="payload => (client.clientOrigin = payload)"
                        />
                    </div>
                    <base-number-input
                        placeholder="0"
                        :max="100"
                        label="Pourcentage du CA"
                        v-model="client.caPercentage"
                        :hasError="$v.client.caPercentage.$error"
                        :errorMessage="
                            errorMessage(
                                'Pourcentage du CA',
                                $v.client.caPercentage
                            )
                        "
                        @blur="$v.client.caPercentage.$touch()"
                    />
                    <base-number-input
                        placeholder="0"
                        label="Délai de paiement en jours"
                        v-model="client.paymentDeadline"
                        :hasError="$v.client.paymentDeadline.$error"
                        :errorMessage="
                            errorMessage(
                                'Délai de paiement en jours',
                                $v.client.paymentDeadline
                            )
                        "
                        @blur="$v.client.paymentDeadline.$touch()"
                    />
                    <label
                        class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                        >Modalité de paiement</label
                    >
                    <div class="flex">
                        <base-tag-multi
                            :tags="paymentList"
                            :values="client.paymentType"
                            @input="checkedHandler"
                        />
                    </div>
                    <div class="flex justify-end mt-4 ">
                        <base-secondary-button
                            color="red"
                            title="Supprimer"
                            @click="removeClient"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tagGroup from "@/components/forms/TagGroup";
import RadioBox from "@/components/forms/Toggles/radioBox";
import IconTrash from "@/components/icons/trash";
import {
    required,
    decimal,
    integer,
    minLength,
    maxLength,
    maxValue,
    minValue
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { mapGetters } from "vuex";

export default {
    components: {
        tagGroup,
        RadioBox,
        IconTrash
    },

    mixins: [errorMessage],

    validations: {
        client: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(75)
            },
            caPercentage: {
                decimal,
                minValue: minValue(0),
                maxValue: maxValue(100)
            },
            paymentDeadline: { integer, minValue: minValue(0) }
        }
    },

    props: {
        data: {
            type: Object
        }
    },

    mounted() {
        this.tags.forEach(elem => {
            if (elem.value === this.data.type) elem.isActive = true;
        });

        this.paymentList.forEach(item => {
            if (this.data.paymentType.includes(item.title))
                item.isChecked = true;
        });
    },

    data() {
        return {
            clientType: "client",
            client: this.data,
            tags: [
                { name: "Client", value: "client", isActive: false },
                { name: "Fournisseur", value: "fournisseur", isActive: false }
            ],
            show: false,
            paymentList: [
                { title: "Espèce", isChecked: false },
                { title: "Chèque", isChecked: false },
                { title: "Lettre de change", isChecked: false },
                { title: "Virement", isChecked: false }
            ]
        };
    },
    methods: {
        checkClientType(e) {
            this.client.type = e;
        },
        checkedHandler(payload) {
            let index = this.paymentList.findIndex(
                paymentMethod => paymentMethod.title == payload
            );
            if (this.client.paymentType.includes(payload)) {
                this.client.paymentType.splice(
                    this.client.paymentType.indexOf(payload),
                    1
                );
                this.paymentList[index].isChecked = false;
            } else {
                this.paymentList[index].isChecked = true;
                this.client.paymentType.push(payload);
            }
        },
        createClient() {
            this.$v.$touch();
            // this.client.type = this.clientType;
            if (!this.$v.$invalid) {
                this.$store.dispatch("VotreProject/createClient", this.client);
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        },
        removeClient() {
            this.$emit("remove", this.client.id);
        }
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        })
    }
};
</script>

<style></style>
